var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.7768 51.2312L28.0075 53.4235L19.2382 51.2312V45.7504H36.7768V51.2312Z",
    fill: "#7DEBF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4307 40.2695H34.5846V47.9427H21.4307V40.2695Z",
    fill: "#7CCC90"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5461 26.0195C45.5461 35.7051 37.6931 43.5581 28.0075 43.5581C18.3219 43.5581 10.4689 35.7051 10.4689 26.0195C10.4689 16.3338 18.3219 8.48083 28.0075 8.48083C37.6931 8.48083 45.5461 16.3338 45.5461 26.0195Z",
    fill: "#7CCC90"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4307 45.7504H34.5846V49.0389H21.4307V45.7504Z",
    fill: "#3CC0D2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8153 27.1156H30.2V45.7504H25.8153V27.1156Z",
    fill: "#329F4C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0075 34.5404L20.3344 27.1156H35.6806L28.0075 34.5404Z",
    fill: "#329F4C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8153 3H30.2V6.28849H25.8153V3Z",
    fill: "#7CCC90"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.112L13.1301 8.04407L15.5964 10.5597L12.4642 13.6277L10 11.112Z",
    fill: "#7CCC90"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4335 10.4933L42.8998 8.02698L45.9999 11.1271L43.5336 13.5934L40.4335 10.4933Z",
    fill: "#7CCC90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.ddf7f321ddb8a055abd51e313e19ba22.svg";
export { ForwardRef as ReactComponent };